<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page -->
            <h1 class="page__title text-capitalize">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body position-relative">
            <CContainer fluid>
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
            </CContainer>
            <CContainer fluid>
                <CRow class="mt-5">
                    <CCol md="12">
                        <CCard class="position-relative shadow">
                            <CCardHeader>
                                <CContainer :fluid="true">
                                    <CRow>
                                        <CCol>
                                            <TableSettings
                                                :allFields="
                                                    tables.logs.allFields
                                                "
                                                :activeFields.sync="
                                                    tables.logs.fields
                                                "
                                            />
                                        </CCol>
                                    </CRow>
                                </CContainer>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.logs.items"
                                    :fields="
                                        traslateArrayObjects({
                                            array: tables.logs.fields,
                                            fields: ['label'],
                                        })
                                    "
                                    :columnFilterValue.sync="
                                        tables.logs.columnFilterValue
                                    "
                                    :sorterValue.sync="tables.logs.sorterValue"
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    v-bind="tables.logs"
                                >
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="'/brevo/gethistorylogs'"
                                                :baseURL="baseURL"
                                                :table="tables.logs"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter>
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.logs.page"
                                        :pages="tables.logs.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.logs.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Mixins
 */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

import FilterDate from "~/components/FilterDate";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import LogsTable from "./config/tables/LogsTable";
import { QueryBuilder } from "~/utils/queryBuilder.js";
import { mapGetters } from "vuex";

export default {
    name: "StatisticsLogs",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        TableSettings,
        ButtonExport,
    },
    data() {
        return {
            tables: {
                logs: LogsTable,
            },
            baseURL: null,
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),
    },
    methods: {
        async updateData() {
            this.updatePageLoading(true);
            await this.updateTable({
                tableName: "logs",
                baseURL: this.baseURL,
                url: "/brevo/gethistorylogs",
                adapterFilters: this.adapterFiltersToUseDate,
            });
            this.updatePageLoading(false);
        },
        adapterFiltersToUseDate(query) {
            query = new QueryBuilder(query);
            query.createdAtToDate();
            return query.getQuery();
        },
    },
    mounted() {
        this.baseURL = process.env.VUE_APP_API_SASS;
        this.updateData();
    },
};
</script>

<style></style>
